module.exports = __webpack_public_path__ + "assets_app/img/titel-startpagina.537765f5.svg";